//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from 'vuex'
import {fetchOrderDetail, orderPay} from '@/api/order'
import {formatTime} from '@/utils/index'

export default {
  computed: {
    ...mapGetters([
      'profile'
    ])
  },
  data () {
    return {
      orderStatusItems: ['创建稿件', '待支付', '待发布', '发布完成'],
      orderStatus: '',
      orderId: '',
      orderData: {}
    }
  },
  methods: {
    getOrderDetail () {
      fetchOrderDetail(this.orderId).then(resp => {
        const createdTime = formatTime(resp.data.created_at)
        const paidTime = resp.data.paid_at ? formatTime(resp.data.paid_at) : ''
        this.orderData = {
          ...resp.data,
          completed_at: formatTime(resp.data.completed_at),
          orderId: resp.data.order_id,
          orderTaxonomy: resp.data.taxonomy_text,
          createdTime,
          paidTime
        }
        if (resp.data.completed_at) {
          this.orderStatus = 3
        } else if (resp.data.paid_at) {
          this.orderStatus = 2
        } else if (resp.data.manuscript) {
          this.orderStatus = 1
        } else {
          this.orderStatus = 0
        }
      }).catch((e) => console.log('error', e))
    },
    handchooseManuscript () {},
    handlePay () {
      const balance = parseInt(this.profile.balance)
      const amount = parseInt(this.orderData.amount)
      // const _this = this
      // 判断用户余额是否充足
      if (balance < amount) {
        console.log('余额不足')
        this.$vux.confirm.show({
          content: '支付失败，账户余额不足，请先充值',
          onConfirm () {
            // console.log(this) // 非当前 vm
            // console.log(_this) // 当前 vm
            // _this.$router.replace(`/recharge`)
          }
        })
      } else {
        const _this = this
        this.$vux.confirm.show({
          content: `确认为订单支付${amount}元`,
          onConfirm () {
            // console.log(this) // 非当前 vm
            // console.log(_this) // 当前 vm
            orderPay(_this.orderId).then(resp => {
              _this.getOrderDetail()
              _this.$router.replace(`/pay-success`)
            }).catch((e) => { console.log(e) })
          }
        })
      }
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.orderId = this.$route.params.id
      this.getOrderDetail()
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/orderDetail/index.vue